// Layout/Rail — the 72px rail (Design Standard v1, shell sign-off change). Brand
// mark at the top, then the navigation grouped Work / Money / Setup: each group
// name is a small divider, each item is its icon with its word under it. The
// active item is accent ink with a 2px left edge, no fill. An "expand" control at
// the bottom widens the rail so the words sit beside the icons; the choice is
// remembered per browser. Industry and role gating come from shellNav.
import React, { useContext, useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FiChevronsRight, FiChevronsLeft } from 'react-icons/fi';
import { AuthContext } from '../../App';
import useShellNav from './shellNav';
import navIcon from './navIcons';

export const RAIL_WIDE_KEY = 'crm.shell.railWide';
export function readRailWide() {
  try { return localStorage.getItem(RAIL_WIDE_KEY) === '1'; } catch { return false; }
}

// Words that do not fit under a 72px icon at 10px. Everything else wraps or fits.
const SHORT = { Communications: 'Comms' };

export function BrandMark({ size = 32, onClick, className = '' }) {
  const { tenant } = useContext(AuthContext);
  const branding = tenant?.preferences?.branding || {};
  const logo = branding?.logo_url || branding?.logo || tenant?.logo || '';
  const name = tenant?.name || 'Abon';
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [logo]);
  return (
    <button type="button" className={`shell-brand ${className}`} onClick={onClick} aria-label={`${name} — home`} title={name} style={{ width: size, height: size }}>
      {logo && !broken ? <img src={logo} alt="" onError={() => setBroken(true)} /> : <span>{name.trim()[0]?.toUpperCase() || 'A'}</span>}
    </button>
  );
}

export default function Rail({ wide = false, onToggleWide }) {
  const navigate = useNavigate();
  const { groups } = useShellNav();
  return (
    <nav className={`rail ${wide ? 'is-wide' : ''}`} aria-label="Primary">
      <BrandMark onClick={() => navigate('/dashboard')} />
      <div className="rail__groups">
        {groups.map((g) => (
          <section key={g.key} className="rail__group" aria-label={g.label}>
            <h2 className="rail__divider"><span>{g.label}</span></h2>
            <ul>
              {g.items.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    className={`rail__link ${item.active ? 'is-active' : ''}`}
                    aria-current={item.active ? 'page' : undefined}
                    title={item.label}
                  >
                    <span className="rail__icon">
                      {navIcon(item.icon)}
                      {item.badge > 0 ? <span className="rail__badge" aria-label={`${item.badge} pending`}>{item.badge > 99 ? '99+' : item.badge}</span> : null}
                    </span>
                    <span className="rail__word">{wide ? item.label : (SHORT[item.label] || item.label)}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
      {onToggleWide ? (
        <button
          type="button"
          className="rail__expand"
          onClick={onToggleWide}
          aria-pressed={wide}
          aria-label={wide ? 'Compact navigation' : 'Expand navigation'}
          title={wide ? 'Compact navigation' : 'Expand navigation'}
        >
          {wide ? <FiChevronsLeft size={16} aria-hidden="true" /> : <FiChevronsRight size={16} aria-hidden="true" />}
        </button>
      ) : null}
    </nav>
  );
}
